var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgNubank = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#820AD1"
  }), React.createElement("path", {
    d: "M9.61238 11.9532C10.2444 11.3516 11.0804 11 12.0684 11C13.9884 11 15.2604 12.2686 15.5044 14.1714C15.5844 14.7912 15.5844 15.6611 15.5804 16.6687V20.7644H12.9404V17.9699C12.9404 17.9699 12.9364 15.5777 12.9204 15.1283C12.8484 13.182 11.5764 11.9569 9.61238 11.9532C9.01638 12.5259 8.70038 13.2182 8.65238 14.2802C8.64438 14.4288 8.64838 14.9543 8.64838 15.643C8.64838 16.0018 8.65238 16.4041 8.65238 16.8246V20.768H6.01238V16.4657C6.01238 16.3171 6.00838 16.1685 6.00838 16.0199C6.00438 15.7191 5.99638 15.4183 6.01238 15.1174C6.04038 14.6173 6.13638 14.1243 6.39638 13.6676C6.98438 12.6238 8.19238 11.9496 9.47638 11.9496C9.52038 11.9496 9.56438 11.9532 9.61238 11.9532Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M25.988 16.8826C26.004 16.5817 26 16.2809 25.992 15.9801C25.988 15.8314 25.988 15.6828 25.988 15.5342V11.232H23.348V15.1754C23.348 15.5959 23.348 15.9982 23.352 16.357C23.356 17.0493 23.356 17.5748 23.348 17.7198C23.3 18.7818 22.984 19.4741 22.392 20.0431C20.428 20.0431 19.152 18.818 19.084 16.8717C19.068 16.4259 19.06 15.3131 19.06 14.0301V11.2283L16.42 11.232V15.3276C16.42 16.3353 16.42 17.2088 16.496 17.8249C16.74 19.7278 18.012 20.9964 19.932 20.9964C20.916 20.9964 21.756 20.6448 22.388 20.0431C22.432 20.0431 22.476 20.0467 22.524 20.0467C23.812 20.0467 25.016 19.3726 25.604 18.3287C25.864 17.872 25.96 17.3827 25.988 16.8826Z",
    fill: "white"
  }));
};
export default SvgNubank;